import { apiFetch } from './utils/api';
// const mockedWebinars = require('./mocks/v2/webinars.json');

export const webinars = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v2/webinars';

    //return mockedWebinars;
    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
